"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _AppAssetListStorage2 = _interopRequireDefault(require("./__generated__/AppAssetListStorage.graphql"));
var _AppAssetListAssets2 = _interopRequireDefault(require("./__generated__/AppAssetListAssets.graphql"));
var React = _interopRequireWildcard(require("react"));
var _reactRelay = require("react-relay");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _AppAssetSection = _interopRequireDefault(require("web/shared/assets/AppAssetSection"));
var _styles = require("web/shared/assets/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The declared app assets and, under them, the keys no screen declares.
*
* This is the suspending half of the assets page: it reads on render and
* leaves the waiting and the failing to the boundary above it, which is why
* it holds no loading state and no error state of its own.
*
* It reads twice because the two answers are independent — what the assets
* are, and whether this product has a bucket to upload to. Both are wanted
* before anything is drawn, so they share one boundary rather than each
* getting their own: a strip rendered before we know whether uploading is
* possible would offer an action that cannot work.
*/
const ASSETS = _AppAssetListAssets2.default;
const STORAGE = _AppAssetListStorage2.default;
function AppAssetList(props) {
  const assets = (0, _reactRelay.useLazyLoadQuery)(ASSETS, {}, {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  });
  const storage = (0, _reactRelay.useLazyLoadQuery)(STORAGE, {}, {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  });
  const hasBucket = storage.internalAppAssetStorage.hasBucket;
  const listed = assets.internalAppAssets;
  if (listed.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.status)), {}, {
      children: "No screen declares an app asset yet."
    }));
  }
  const sectionFor = asset => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppAssetSection.default, {
    asset: asset,
    hasBucket: hasBucket,
    onChanged: props.onChanged
  }, asset.key);
  const declared = listed.filter(asset => asset.declared);
  const undeclared = listed.filter(asset => !asset.declared);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [declared.map(sectionFor), undeclared.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.orphansHeading)), {}, {
        children: "Not declared"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.orphansNote)), {}, {
        children: "Candidates for keys no screen declares any more. They are kept until deleted here; declaring the key again brings them back."
      })), undeclared.map(sectionFor)]
    }) : null]
  });
}
var _default = exports.default = AppAssetList;